<template>
  <div>
 <b-modal
      centered
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      cancel-disabled
      v-model="show"
    >
    <template #modal-header>
       <div class="logo"><img class="img-fluid" src="/static/editorinnen_logo_final_1920px.png"/></div>
    </template>
     <template #modal-backdrop>
     <div class="gradiant"/>
     </template>
   <b-overlay :show="loading">
     <template #overlay>
       <b-spinner label="Laden..."></b-spinner>&nbsp;<span>Bitte warten...</span>
      </template>
   <b-container fluid>

        <div class="form-group">
          <label for="username">Login</label>
          <input
            v-model="userForm.username"
            required="required"
            type="text"
            class="form-control"
            name="username"
          />
          <div
            v-if="message['username']"
            class="alert alert-danger"
            role="alert"
          >Bitte Login eingeben</div>
        </div>
        <div class="form-group">
          <label for="password">Passwort</label>
          <input
            v-model="userForm.password"
            required="required"
            type="password"
            class="form-control"
            name="password"
          />
          <div
            v-if="message['password']"
            class="alert alert-danger"
            role="alert"
          >Bitte Passwort eingeben</div>
        </div>
        <div>
       <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
        </div>
    </b-container>
    </b-overlay>
       <template #modal-footer>
        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading" @click="submit">
            <span>Einloggen</span>
          </button>
        </div>
        </template>
 </b-modal>
  </div>
</template>

<script>
import UserForm from '@/models/UserForm'
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  components: {},
  data () {
    return {
      userForm: new UserForm('', ''),
      loading: false,
      show: true,
      message: ''
    }
  },
  created () {
    let that = this
    document.onkeydown = function (e) {
      e = e || window.event
      switch (e.which || e.keyCode) {
        case 13:
          that.submit()
          break
      }
    }
  },
  methods: {
    ...mapActions(['LogIn']),
    async submit () {
      const User = new FormData()
      User.append('username', this.userForm.username)
      User.append('password', this.userForm.password)
      try {
        this.loading = true
        let loggedIn = await this.LogIn(User)
        this.loading = false
        if (loggedIn) {
          this.$emit('logged:in', User) // FIXME still needed?
          if (this.$route.query.returnUrl) {
            this.$router.push({path: this.$route.query.returnUrl})
          } else {
            this.$router.push({path: '/anfragen'})
          }
        } else {
          this.message = 'Fehler bei der Anmeldung!'
        }
      } catch (error) {
        this.message = 'Fehler bei der Anmeldung!'
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
label {
  display: block;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Login.vue